import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-background-animation',
  template: `
    <div class="auth-background" aria-hidden="true">
      <span class="auth-background__glow auth-background__glow--primary"></span>
      <span class="auth-background__glow auth-background__glow--accent"></span>
      <span class="auth-background__orb auth-background__orb--top"></span>
      <span class="auth-background__orb auth-background__orb--bottom"></span>
      <svg class="auth-background__contours" viewBox="0 0 720 560" fill="none" preserveAspectRatio="xMaxYMax slice">
        <path d="M367 560c-35-75-8-145 70-174 105-39 86-131 196-170 42-15 69-43 87-77" />
        <path d="M296 560c-47-108-6-207 97-242 102-35 91-120 193-157 57-20 96-55 116-101" />
        <path d="M226 560c-58-142-7-269 124-312 101-33 98-108 186-140 73-26 126-70 154-129" />
      </svg>
      <span class="auth-background__grid"></span>
    </div>
  `,
  styles: `
    :host {
      inset: 0;
      pointer-events: none;
      position: absolute;
      z-index: 0;
    }

    .auth-background {
      background:
        radial-gradient(circle at 12% 14%, rgba(104, 75, 255, 0.42), transparent 27rem),
        radial-gradient(circle at 88% 78%, rgba(45, 195, 210, 0.18), transparent 24rem),
        linear-gradient(135deg, #15132b 0%, #211b45 48%, #15172f 100%);
      height: 100%;
      overflow: hidden;
      position: relative;
      width: 100%;
    }

    .auth-background__glow,
    .auth-background__orb {
      border-radius: 50%;
      position: absolute;
      will-change: transform;
    }

    .auth-background__glow {
      filter: blur(1px);
      opacity: 0.8;
    }

    .auth-background__glow--primary {
      animation: auth-float-primary 18s ease-in-out infinite alternate;
      background: rgba(122, 92, 255, 0.36);
      height: min(52vw, 46rem);
      left: -14rem;
      top: -15rem;
      width: min(52vw, 46rem);
    }

    .auth-background__glow--accent {
      animation: auth-float-accent 21s ease-in-out infinite alternate;
      background: rgba(41, 198, 213, 0.18);
      bottom: -22rem;
      height: min(50vw, 42rem);
      right: -12rem;
      width: min(50vw, 42rem);
    }

    .auth-background__orb {
      border: 1px solid rgba(239, 237, 255, 0.24);
      box-shadow: inset 0 0 3rem rgba(255, 255, 255, 0.06);
    }

    .auth-background__orb--top {
      animation: auth-drift 16s ease-in-out infinite alternate;
      height: 18rem;
      right: 15%;
      top: 12%;
      width: 18rem;
    }

    .auth-background__orb--bottom {
      animation: auth-drift 20s ease-in-out infinite alternate-reverse;
      bottom: -8rem;
      height: 25rem;
      left: 8%;
      opacity: 0.55;
      width: 25rem;
    }

    .auth-background__contours {
      bottom: -2px;
      height: min(70vw, 42rem);
      position: absolute;
      right: -2px;
      stroke: rgba(238, 235, 255, 0.42);
      stroke-width: 1.25;
      width: min(84vw, 56rem);
    }

    .auth-background__grid {
      background-image: radial-gradient(rgba(255, 255, 255, 0.35) 1px, transparent 1px);
      background-size: 1.25rem 1.25rem;
      height: 9rem;
      opacity: 0.18;
      position: absolute;
      right: 8%;
      top: 16%;
      width: 9rem;
    }

    @keyframes auth-float-primary {
      to { transform: translate3d(4rem, 3rem, 0) scale(1.1); }
    }

    @keyframes auth-float-accent {
      to { transform: translate3d(-3rem, -4rem, 0) scale(1.12); }
    }

    @keyframes auth-drift {
      to { transform: translate3d(1.5rem, -1.25rem, 0); }
    }

    @media (prefers-reduced-motion: reduce) {
      .auth-background__glow,
      .auth-background__orb {
        animation: none;
      }
    }

    @media (max-width: 575.98px) {
      .auth-background__grid,
      .auth-background__orb--top {
        display: none;
      }

      .auth-background__contours {
        height: 26rem;
        width: 38rem;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackgroundAnimationComponent {}
